var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    class: _vm.$style.RegistrationReglament,
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect.once",
      value: _vm.onIntersect,
      expression: "onIntersect",
      modifiers: {
        "once": true
      }
    }]
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };